import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { connect } from 'react-redux';
import CommitteeForm from '../CommitteeForm';
import AddMemberForm from '../CommitteeMembers/AddMemberForm';
import AddDocumentForm from '../CommitteeDocuments/AddDocumentForm';
import CommitteeAudit from '../CommitteeAudit/CommitteeAudit';

class DialogContainer extends Component {
    constructor(props) {
        super(props);
        let d = { ...this.props.dataItem };
        d.ParentCommittee = { name: d.ParentCommitteeName, id: d.ParentCommitteeId };
        d.CommitteeType = { description: d.CommitteeType, committeeTypeId: d.CommitteeTypeId };
        d.PositionGroup = { description: d.PositionGroup, positionGroupId: d.PositionGroupId };
        this.state = {
            view: "edit",
            data: Object.keys(this.props.dataItem).length === 0 ? null : d
        };
    }

    componentDidMount() {

    }

    changeVeiw = (view) => {
        this.setState({
            view: view
        })
    }

    render() {
        return (
            <div className="k-window-content">
                <div className="row " style={{width: '100%'}}>
                    <div className="col-md-2 larger-font">
                        {this.state.data != null ?
                            <ul className="subSideNav">
                                <li onClick={() => this.changeVeiw("edit")} className={this.state.view === "edit" ? "active" : ""}>Edit</li>
                                <li onClick={() => this.changeVeiw("add")} className={this.state.view === "add" ? "active" : ""}>Add Member</li>
                                <li onClick={() => this.changeVeiw("documents")} className={this.state.view === "documents" ? "active" : ""}>Documents</li>
                                <li onClick={() => this.changeVeiw("audit")} className={this.state.view === "add" ? "active" : ""}>Audit History</li>
                            </ul>
                            : ""}   
                    </div>
                    <div className="col-md-10">
                        {this.state.view === "edit" ?
                            <CommitteeForm
                                dataItem={ this.state.data != null ? this.state.data: this.props.dataItem }
                                addCommittee={this.props.addCommittee}
                                committeeTypes={this.props.committee.committeeTypes}
                                parentCommittees={this.props.committee.parentCommittees}
                                updateCommittee={this.props.updateCommittee}
                                positionGroups={this.props.position.positionGroups}
                                save={this.props.save}
                                cancel={this.props.cancel}
                            />
                        : ""}
                        {this.state.view === "add" ?
                            <AddMemberForm
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem }
                                save={this.props.save}
                                cancel={this.props.cancel}
                            />
                        : ""}
                        {this.state.view === "documents" ?
                            <AddDocumentForm
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem }
                                save={this.props.save}
                                cancel={this.props.cancel}
                            />
                        : ""}
                        {this.state.view === "audit" ?
                            <CommitteeAudit
                                dataItem={this.state.data != null ? this.state.data : this.props.dataItem}
                                cancel={this.props.cancel}
                            />
                        : ""}   
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        committee: state.committee,
        position: state.position
    };
}

export default connect(mapStateToProps, {})(DialogContainer);
